import { SearchX } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { spacing } from '../constants/theme'
import { FontStyle, Text } from './core'

export const EmptySearchWrapper = styled.div`
  width: 100%;
  padding: 0 40px;
  margin-top: 26px;
  box-sizing: border-box;
`

export const EmptySearchIcon = styled.div`
  width: 100%;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EmptySearchString = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

interface EmptySearchProps {
  search?: string
}

const EmptySearch: React.FC<EmptySearchProps> = ({ search = '' }) => {
  const { t } = useTranslation()

  return (
    <EmptySearchWrapper>
      <EmptySearchIcon>
        <SearchX size={48} color="var(--chakra-colors-fg-muted)" />
      </EmptySearchIcon>
      <Text
        align="center"
        size={FontStyle.Medium}
        text={t('emptySearch.shoot')}
        color="var(--chakra-colors-fg-muted)"
        weight="bold"
      />
      <Text
        align="center"
        size={FontStyle.Normal}
        text={t('emptySearch.nothingIsMatching')}
        color="var(--chakra-colors-fg-muted)"
        style={{ marginBottom: `${spacing.spacingSM}` }}
      />
      <EmptySearchString>
        <Text
          size={FontStyle.Normal}
          text={'"'}
          color="var(--chakra-colors-fg-muted)"
        />
        <Text
          size={FontStyle.Normal}
          text={search}
          color="var(--chakra-colors-fg-default)"
          weight="bold"
        />
        <Text
          size={FontStyle.Normal}
          text={'"'}
          color="var(--chakra-colors-fg-muted)"
        />
      </EmptySearchString>
      <Text
        align="center"
        size={FontStyle.Normal}
        text={t('emptySearch.didYouSpellItRight')}
        color="var(--chakra-colors-fg-default)"
      />
    </EmptySearchWrapper>
  )
}

export default EmptySearch
